import React from 'react';
import PropTypes from 'prop-types';

import { getFullName } from '@utils/formatting';

import ContentfulImage from '@prospectus/common/ui/ContentfulImage';

import Attribution from '../Attribution';

const endoreserLogoSize = 80;

function Endorsement({
  corporationName: corporation,
  image,
  individualEndorsements: endorsements,
}) {
  const { endorser, quote } = endorsements[0];

  return (
    <div className="d-flex callout-wrapper col-12 col-lg-6">
      <div className="content">
        {image
          && (
          <div className="company-endorser-logo-wrapper">
            <ContentfulImage className="company-endorser-logo" url={image.src} title={corporation} width={endoreserLogoSize} />
          </div>
          )}
        {!image && <h3 className="h3">{corporation}</h3>}
        <p className="endorsement">{quote}</p>
        <Attribution
          author={getFullName(endorser)}
          title={endorser.position ? endorser.position.title : ''}
        />
      </div>
    </div>
  );
}

Endorsement.propTypes = {
  corporationName: PropTypes.string.isRequired,
  image: PropTypes.shape({
    src: PropTypes.string,
  }),
  individualEndorsements: PropTypes.arrayOf(PropTypes.shape({
    quote: PropTypes.string,
    endorser: PropTypes.shape({
      familyName: PropTypes.string,
      givenName: PropTypes.string,
      position: PropTypes.shape({
        title: PropTypes.string,
      }),
    }),
  })).isRequired,
};

Endorsement.defaultProps = {
  image: undefined,
};

export default Endorsement;
